import styled from "styled-components";

export const CenterContent = styled.div`
  display: flex;
  width: 100%;
  height: 250px;
  justify-content: center;
  align-items: center;
`;